export * from './inventory-page.module';
export * from './inventory.page';
